<!--
 * @Author: your name
 * @Date: 2020-11-13 13:25:18
 * @LastEditTime: 2021-03-16 14:23:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\views\Home\common\HonorInfo.vue
-->
<template>
  <div id="honorInfo">
    <!-- 协会管理员 -->
    <el-row class="goBackHome" v-if="roleType==2&&$parent.tabIndex==4">
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
        <span class="clickBack" @click="$parent.tabIndex=0"><img src="@/assets/img/back.png" alt="">返回</span>
      </el-col>
      <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
        <span style="color: #333333;">我的工作台 > </span>{{quesNaireData.applyName}}
      </el-col>
    </el-row>
    <!-- 协会会员 -->
    <el-row class="goBackHome" v-if="roleType==3&&$parent.tabIndex==4">
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
        <span class="clickBack" @click="$parent.tabIndex=0"><img src="@/assets/img/back.png" alt="">返回</span>
      </el-col>
      <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
        <span style="color: #333333;">我的申请 > </span>{{quesNaireData.applyName}}
      </el-col>
    </el-row>
    <template v-if="quesNaireData">
      <el-row class="quesStartInfo" v-if="(quesNaireData.recipientPerson==null||quesNaireData.recipientPerson==''||quesNaireData.recipientPerson==userId)&&roleType==2&&quesNaireData.applyStatus!=5&&quesNaireData.applyStatus!=4">
        <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14" class="applyColor">
          <el-row style="margin-bottom:10px;">
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
              公司名 :
              <span class="leftMargin">{{quesNaireData.companyName}}</span>
            </el-col>
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
              发起时间 :
              <span class="leftPadding"> {{quesNaireData.createTime}}</span>
            </el-col>
          </el-row>
          <el-row>
            申请内容 : <span class="leftPadding">{{quesNaireData.applyName}}</span>
          </el-row>
        </el-col>
        <template v-if="quesNaireData.taskStatus==2">
          <el-col class=" taskBack" :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
            <div @click="taskBack">
              任务退回
              <img src="@/assets/img/任务退回.png" alt="">
            </div>
          </el-col>
          <el-col style="text-align:right;margin-right:20px;" :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
            <el-button class="button add esc" @click="isSuccess(5)">同意</el-button>
            <el-button class="button esc" @click="applyVisible=true">拒绝</el-button>
          </el-col>
        </template>
        <template v-if="quesNaireData.taskStatus==1">
          <el-col class="receiveTask" :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
            <el-button class="button receive" @click="acceptTask">接受任务</el-button>
          </el-col>
        </template>
      </el-row>
      <el-row class="applyReason" v-if="roleType == 2 && $route.name == 'AdminApplication'&&remarkReason">
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">原因说明：</el-col>
        <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">{{remarkReason}}</el-col>
      </el-row>
    </template>
    <el-row class="addContact" v-if="roleType==3&&$parent.tabIndex!=4" @click.native="addHonor">
      <i class="el-icon-plus"> 添加资质及补贴信息、荣誉信息</i>
    </el-row>
    <el-table :data="infoTableData" stripe style="width: 100%" class="infoTableData">
      <el-table-column prop="type" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type==1">资质</span>
          <span v-if="scope.row.type==2">补贴</span>
          <span v-if="scope.row.type==3">荣誉</span>
        </template>
      </el-table-column>
      <el-table-column prop="levelType" label="等级">
        <template slot-scope="scope">
          <span v-if="scope.row.levelType==1">国际级</span>
          <span v-if="scope.row.levelType==2">国家级</span>
          <span v-if="scope.row.levelType==3">地市级</span>
          <span v-if="scope.row.levelType==4">区县级</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称">
      </el-table-column>
      <el-table-column prop="subsidies" label="补贴金额（单位：万元）" v-if="quesNaireData && infoTableData[0].type==2">
      </el-table-column>
      <el-table-column prop="originalFileName" label="文件">
        <template slot-scope="scope">
          <el-link class="downLoad" @click="downLoadPay(scope.row.originalFileName,scope.row.file)" :download="scope.row.originalFileName">{{scope.row.originalFileName}}</el-link>
          <!-- <el-link class="downLoad" @click="downLoadPay(scope.row.proofPaymentName,scope.row.proofPayment)" :download="scope.row.proofPaymentName">{{scope.row.proofPaymentName}}</el-link> -->
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="开始时间">
        <template slot-scope="scope">
          {{scope.row.startTime}}
        </template>
      </el-table-column>
      <el-table-column prop="endTime" label="结束时间">
        <template slot-scope="scope">
          {{scope.row.endTime}}
        </template>
      </el-table-column>
      <el-table-column label="操作" v-if="roleType==3&&$parent.tabIndex!=4">
        <template slot-scope="scope">
          <span v-if="scope.row.approveStatus==1" class="applyAdd">申请添加中</span>
          <span v-else-if="scope.row.approveStatus==2" class="applyAdd">申请修改中</span>
          <span v-else-if="scope.row.approveStatus==3" class="applyAdd">申请删除中</span>
          <template v-else-if="scope.row.approveStatus==5">
            <span class="downLoad" @click="editHonor(scope.row)">修改</span>
            <span class="downLoad delete" @click="deleteHonor(scope.row)">删 除</span>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="(roleType == 3||roleType == 2)&&$route.name=='Management'" @current-change="handleCurrentChange" :current-page.sync="honorParams.pageNumber" :page-size="honorParams.pageSize" layout="total, prev, pager, next" :total="totalPage">
    </el-pagination>
    <!-- 添加资质及补贴信息、荣誉信息对话框 -->
    <el-dialog :title="honorTitle" :visible.sync="addHonorVisible" width="30%" custom-class="addInfoVisible" @close="closeHonorDialog" @open="openHonorDialog">
      <el-form :model="addInfoForm" :rules="addInfoFormRules" ref="addInfoFormRef" label-width="130px" class="demo-ruleForm" v-if="addSuccess==0">
        <el-form-item label="类型" prop="type">
          <el-select v-model="addInfoForm.type" placeholder="请选择类型" @change="changeInfoFormType">
            <el-option v-for="item in typeData" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="等级" prop="levelType">
          <el-select v-model="addInfoForm.levelType" placeholder="请选择等级">
            <el-option v-for="item in levelData" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name" class="name">
          <el-input v-model="addInfoForm.name" class="quaName"></el-input>
        </el-form-item>
        <el-form-item label="日期" prop="selectTime">
          <el-select popper-class="dateSelect" v-model="addInfoForm.selectTime" placeholder="请选择日期" clearable @change="selectChange" @clear="clearSelect">
            <el-option label="永久" value="1"></el-option>
            <el-option value=" ">
              <!-- <el-date-picker v-model="timeValue" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange" popper-class="datePicker" :picker-options="pickerDisabled">
              </el-date-picker> -->
              <el-date-picker v-model="timeValue" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange" popper-class="datePicker">
              </el-date-picker>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="补贴金额" prop="subsidies" class="name" v-show="addInfoForm.type == 2">
          <el-input v-model="addInfoForm.subsidies" class="quaName" @input="updateInput()" ></el-input><span class="unit">单位/万元</span>
        </el-form-item>
        <el-form-item label="修改原因" prop="remark" v-if="isHonor==2">
          <el-input class="editReason" type="textarea" v-model="addInfoForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="文件" prop="file" >
          <el-upload class="upload-demo" :headers="headerObj" :action="uploadUrl" :on-success="honorSuccess" :on-remove="removeHonor" :before-upload="beforeAvatarUpload" :file-list="honorList">
            <span class="uploaadImg"><img src="@/assets/img/上传.png" alt="">点击上传</span>
            <!-- <span slot="tip" class="el-upload__tip" :style="{color:activeColor}">{{message}}</span> -->
          </el-upload>
        </el-form-item>
      </el-form>
      <div v-if="addSuccess==1" style="text-align:center;">
        <img src="@/assets/img/修改成功.png" alt="">
        <p style="font-size:16px;font-weight:700;margin:15px 0;">提交成功</p>
        <span v-if="isHonor==1">添加资质及补贴信息、荣誉信息已提交,正等待管理员审核!</span>
        <span v-if="isHonor==2">修改资质及补贴信息、荣誉信息已提交,正等待管理员审核!</span>
        <span v-if="isHonor==3">删除资质及补贴信息、荣誉信息已提交,正等待管理员审核!</span>
      </div>
      <el-row v-if="addSuccess==2">
        <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" style="padding-left:20px;font-size:15px;">删除原因</el-col>
        <el-col :xs="19" :sm="19" :md="19" :lg="19" :xl="19">
          <el-input type="textarea" class="deleteReason" placeholder="请填写删除原因" v-model="addInfoForm.remark"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <span v-if="addSuccess==0" class="button add" type="primary" @click="addHonorList">确 定</span>
        <span v-if="addSuccess==1" class="button add" type="primary" @click="addSuccessfull">确定</span>
        <span v-if="addSuccess==2" class="button add" type="primary" @click="deleteInfo">确定</span>
        <span class="button" v-if="addSuccess==0||addSuccess==2" @click="addHonorVisible = false">取 消</span>
      </span>
    </el-dialog>
    <!-- 审批 -->
    <el-dialog title="审批拒绝" :visible.sync="applyVisible" width="25%" custom-class="addInfoVisible" @close="closeApplyDialog">
      <el-row>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">拒绝原因:</el-col>
        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
          <el-input type="textarea" v-model="reasonPrams.comment" placeholder="请填写拒绝原因"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <span class="button add" type="primary" @click="isSuccess(4)">确 定</span>
        <span class="button" type="primary" @click="applyVisible=false">取 消</span>
      </span>
    </el-dialog>
    <!-- 任务退回对话框 -->
    <BackDialog ref="BackDialog" />
  </div>
</template>
<script>
import BackDialog from '@/views/Home/common/BackDialog.vue'
import { findHonorInfo, addHonorInfo, delHonorInfo, applyRecord, downLoadFile, taskManagement } from '@/api/index'
import { downLoadFiles } from '@/assets/js/common'
export default {
  props: ['quesNaireData'],
  data() {
    var valiFile = (rule, value, callback) => { // 文件验证
      if (this.honorList.length == 0) {
        callback(new Error('请上传文件'));
      }  else {
        callback();
      }
    }
    return {
      userId: sessionStorage.getItem('userId'),
      roleType: window.sessionStorage.getItem('roleType'),
      headerObj: { token: window.sessionStorage.getItem('token') },
      uploadUrl: '', // 单文件
      infoTableData: [],
      addInfoVisible: false,
      timeValue: '',
      addInfoForm: {
        id: "",
        type: '',
        levelType: '',
        name: '',
        subsidies: '',
        startTimeStr: '',
        endTimeStr: '',
        file: '',
        originalFileName: '',
        selectTime: "",
        remark: ""
      },
      addInfoFormRules: {
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        levelType: [
          { required: true, message: '请选择等级', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        selectTime: [
          { required: true, message: '请选择日期', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入修改原因', trigger: 'blur' },
        ],
        file: [
          { required: true, validator: valiFile, trigger: 'change' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
      },
      isHonor: '', //1添加 2修改
      addHonorVisible: false,
      honorList: [],
      honorParams: {
        pageNumber: 1,
        pageSize: 5,
        userId: ''
      },
      totalPage: 0,
      typeData: [
        {
          value: 1,
          label: '资质'
        },
        {
          value: 2,
          label: '补贴'
        },
        {
          value: 3,
          label: '荣誉'
        },
      ],
      levelData: [
        {
          value: 1,
          label: '国际级'
        },
        {
          value: 2,
          label: '国家级'
        },
        {
          value: 3,
          label: '地市级'
        },
        {
          value: 4,
          label: '区县级'
        },
      ],
      applyVisible: false,
      reasonPrams: {
        id: '',
        applyStatus: '',
        comment: ''
      },
      //禁用当天之前的时间
      // pickerDisabled: {
      //   disabledDate: (time) => {
      //     return time.getTime() < Date.now() - 8.64e7;
      //   }
      // },
      addSuccess: 0,
      honorTitle: "",
      remarkReason: "",
    }
  },
  created() {
    this.uploadUrl = this.$http.defaults.baseURL + 'user/uploadFile'
    this.getHonorInfo()
  },
  methods: {
    // 解决input无法输入
    updateInput(){
      this.$forceUpdate()
    },
    changeInfoFormType(val){
      // 类型不是“补贴”的话，置空“补贴金额”
      if(val != 2){
        this.addInfoForm.subsidies = ''
      }
    },
    // 任务退回
    taskBack() {
      this.$refs.BackDialog.titleName = '任务退回'
      this.$refs.BackDialog.refuseVisible = true
      this.$refs.BackDialog.step = 1
      this.$refs.BackDialog.receiveParams.id = this.quesNaireData.id
    },
    // 接受任务
    async acceptTask() {
      this.$refs.BackDialog.receiveParams.id = this.quesNaireData.id
      this.$refs.BackDialog.receiveParams.taskStatus = 2
      const { data } = await taskManagement(this.$refs.BackDialog.receiveParams)
      if (data.code != 0) return
      this.quesNaireData.taskStatus = 2
      this.$parent.findAllTask()
      // this.$parent.$parent.$parent.$parent.getApplyNums()

    },
    // 上传文件前校验
    beforeAvatarUpload(file) {
      // var FileExt = file.name.replace(/.+\./, "");
      // if (['zip', 'rar', 'gz', ".apk"].indexOf(FileExt.toLowerCase()) === -1) {
      //   this.activeColor = 'red'
      //   this.message = "文件格式有误，请重新上传!"
      //   return false;
      // } else if (file.size / 1024 / 1024 > 40) {
      //   this.activeColor = 'red'
      //   this.message = "文件大于100M，请重新上传!"
      // }
      // this.activeColor = '#999'
      // this.message = "上传中,请稍等..."
    },
    async getHonorInfo() {
      if ((this.roleType == 2 && this.$route.name == 'AdminApplication') || (this.roleType == 3 && this.$route.name == 'Application')) {
        let param = JSON.parse(this.quesNaireData.param)
        param.startTime = this.$dayjs(param.startTime).format("YYYY-MM-DD")
        param.endTime = this.$dayjs(param.endTime).format("YYYY-MM-DD")
        if (param.endTime == "2100-01-01") {
          param.endTime = '永久'
        }
        this.remarkReason = param.remark
        this.infoTableData = [param]

      } else {
        if (this.roleType == 2 && this.$route.name == 'Management') {
          this.honorParams.userId = this.$route.query.id
        } else {
          this.honorParams.userId = this.userId
        }
        const { data } = await findHonorInfo(this.honorParams)
        if (data.code != 0) return
        this.infoTableData = JSON.parse(JSON.stringify(data.honorInformationList))
        this.totalPage = data.total
        this.infoTableData.map(item => {
          item.startTime = this.$dayjs(item.startTime).format("YYYY-MM-DD")
          if (item.endTime == "2100-01-01 00:01:00") {
            item.endTime = '永久'
          } else {
            item.endTime = this.$dayjs(item.endTime).format("YYYY-MM-DD")
          }
        })
      }
    },
    handleCurrentChange(val) {
      this.infoTableData.pageNumber = val
      this.getHonorInfo()
    },
    addHonor() {
      this.isHonor = 1
      this.honorTitle = '添加资质及补贴信息、荣誉信息'
      this.addSuccess = 0
      this.addHonorVisible = true
    },
    editHonor(row) {
      this.addHonorVisible = true
      this.addSuccess = 0
      this.isHonor = 2
      this.honorTitle = '修改资质及补贴信息、荣誉信息'
      this.addInfoForm.id = row.id
      this.addInfoForm.type = row.type
      this.addInfoForm.levelType = row.levelType
      this.addInfoForm.name = row.name
      this.addInfoForm.subsidies = row.subsidies
      this.addInfoForm.originalFileName = row.originalFileName
      this.addInfoForm.file = row.file
      if (row.endTime == "2100-01-01 00:01:00") {
        this.addInfoForm.selectTime = '永久'
      } else {
        this.addInfoForm.selectTime = `${row.startTime.slice(0, 10)}至${row.endTime.slice(0, 10)}`
      }
      this.honorList.push({
        name: row.originalFileName,
        url: row.file
      })
    },
    deleteHonor(row) {
      this.honorTitle = '申请删除'
      this.isHonor = 3
      this.addSuccess = 2
      this.addHonorVisible = true
      this.addInfoForm.id = row.id
    },
    async deleteInfo() {
      const { data } = await delHonorInfo(this.addInfoForm)
      if (data.code !== 0) return
      this.addSuccess = 1
      // this.getHonorInfo()
    },
    addHonorList() {
      
      this.$refs.addInfoFormRef.validate(async (valid, obj) => {
        if (valid) {
          const { data } = await addHonorInfo(this.addInfoForm)
          if (data.code != 0) return
          this.addSuccess = 1
        }
      })
    },
    addSuccessfull() {
      this.addHonorVisible = false
      this.getHonorInfo()
    },
    openHonorDialog() {
      if (this.isHonor == 1) {
        this.addInfoForm = {}
        this.honorList = []
      }
    },
    honorSuccess(file, fileList) {
      this.$refs.addInfoFormRef.clearValidate()
      if (fileList.status == 'success') {
        this.addInfoForm.file = fileList.response.fileUrl
        this.addInfoForm.originalFileName = fileList.name
      }
      this.honorList.push({ name: fileList.name, url: fileList.response.fileUrl })
      
    },
    removeHonor(file) {
      const filePath = file.url
      // //使用findIndex来查找符合条件的索引
      const index = this.honorList.findIndex(item => item.url === filePath)
      // //移除索引对应的图片
      this.honorList.splice(index, 1)
    },
    timeChange(val) {
      if (val == '' || val == null) {
        this.addInfoForm.startTimeStr = ''
        this.addInfoForm.endTimeStr = ''
        this.addInfoForm.selectTime = ''
      } else {
        this.addInfoForm.startTimeStr = this.$dayjs(val[0]).format("YYYY-MM-DD HH:mm:ss")
        this.addInfoForm.endTimeStr = this.$dayjs(val[1]).format("YYYY-MM-DD HH:mm:ss")
        this.addInfoForm.selectTime = `${this.$dayjs(val[0]).format("YYYY-MM-DD")}至${this.$dayjs(val[1]).format("YYYY-MM-DD")}`
      }

    },
    closeHonorDialog() {
      if (this.addSuccess == 1 || this.addSuccess == 2) {
        this.addInfoForm = {
          id: "",
          type: '',
          levelType: '',
          name: '',
          subsidies: '',
          startTimeStr: '',
          endTimeStr: '',
          file: '',
          originalFileName: '',
          selectTime: "",
        }
        this.timeValue = ''
      } else {
        this.$refs.addInfoFormRef.resetFields()
      }
      this.honorList = []
    },
    //审批
    async isSuccess(status) {
      this.reasonPrams.id = this.quesNaireData ? this.quesNaireData.id : ''
      this.reasonPrams.applyStatus = status
      const { data } = await applyRecord(this.reasonPrams)
      if (data.code != 0) return
      this.$parent.tabIndex = 0
      this.$parent.findAllTask()
    },
    closeApplyDialog() {
      this.reasonPrams.comment = ''
    },
    // 下载文件
    // async downLoad(row) {
    //   // const { data } = await downLoadFile(row.originalFileName, row.file)
    //   // let url = window.URL.createObjectURL(new Blob([data]))
    //   // let link = document.createElement('a')
    //   // link.style.display = 'none'
    //   // link.href = url
    //   // // 获取文件名
    //   // // download 属性定义了下载链接的地址而不是跳转路径
    //   // link.setAttribute('download', row.originalFileName) //设置下载的名称
    //   // document.body.appendChild(link)
    //   // link.click()

    // },
    downLoadPay(fileName, file) {
      downLoadFiles(fileName, file)
    },
    //日期选择下拉
    selectChange(val) {
      if (val == '1') {
        this.addInfoForm.endTimeStr = '永久'
      }
    },
    clearSelect() {
      this.timeValue = ''
    },
  },
  components: {
    BackDialog
  }
}
</script>
<style lang='less' scoped>
#honorInfo {
  .uploaadImg {
    display: inline-block;
    width: 134px;
    height: 34px;
    line-height: 34px;
    border-radius: 17px;
    border: solid 1px #0566cc;
    color: #0066cc;
    font-size: 16px;
    margin-right: 15px;
    cursor: pointer;
    img {
      vertical-align: middle;
      padding-right: 5px;
    }
  }
  // 添加资质及补贴信息、荣誉信息对话框
  /deep/.addInfoVisible {
    .el-select,
    .el-input {
      width: 88% !important;
    }
    .quaName {
      width: 77.5% !important;
    }
    .unit {
      display: inline-block;
      color: #ccc;
      margin-left: 10px;
    }
    .el-date-editor--daterange.el-input__inner {
      width: 389px;
    }
    .add {
      background-color: #0e6fd0;
      color: #fff;
      margin-right: 20px;
    }
    .el-upload-list__item {
      width: 80%;
    }
  }
}
</style>